import { render, staticRenderFns } from "./EmptyComponent.vue?vue&type=template&id=4673b524"
import script from "./EmptyComponent.vue?vue&type=script&lang=ts"
export * from "./EmptyComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports